export const getLocalLinkIP = () => {
    return new Promise((resolve, reject) => {
        const pc = new RTCPeerConnection({ iceServers: [] });
        const noop = function () { };

        pc.createDataChannel(""); // create a bogus data channel
        pc.createOffer(pc.setLocalDescription.bind(pc), noop); // create offer and set local description

        pc.onicecandidate = function (ice) {
            console.log("ice candidate: ", ice)
            if (ice && ice.candidate && ice.candidate.address) {
                const ip = ice.candidate.address;
                console.log("Recieved IP: ", ip);
                // check if ip ends with .local
                if (ip.endsWith(".local") || ip.startsWith("192.168")) {
                    resolve(ip);
                    pc.close();
                }
            }
        };

        // Handle case where no local-link IP is found
        setTimeout(() => reject(new Error('Local link IP not found')), 2000); // Timeout after 5 seconds
    });
};
